import { gql } from "@apollo/client";

const query = gql`
  query Query(
    $filterCompany: FilterFindOneCompanyInput,
    $filterAccounts: FilterFindManyAccountInput,
  ) {
    companyOne(
      filter: $filterCompany
    ) {
      alias
      domain
      name
      integrations
    }
    accountMany(
      filter: $filterAccounts
    ) {
      _id
      companyAlias
      email
      name
      title
      role
      activities {
        date
        type
        action
      }
    }
    emailTemplateFindMany {
      _id
      name
      subject
      content
    }
  }
`;

const account = gql`
  query AccountById($id: MongoID!) {
    accountById(_id: $id) {
      _id
      email
      name
      title
      role
      integrations {
        mail {
          email
          provider
        }
      }
    }
  }
`;

const accounts = gql`
  query AccountMany($filter: FilterFindManyAccountInput) {
    accountMany(filter: $filter) {
      _id
      companyAlias
      email
      name
      title
      role
      activities {
        date
        type
        action
      }
    }
  }
`;

const listingDac = gql`
  query Query($filter: FilterFindOneListingInput) {
    listingFindOne(filter: $filter) {
      _id
      companyAlias
      name
      guests
    }
  }
`;

const updateGuests = gql`
  mutation Mutation($filter: FilterUpdateOneListingInput, $record: UpdateOneListingInput!) {
    listingUpdateOne(filter: $filter, record: $record) {
      record {
        _id
      }
    }
  }
`;

const updateAccount = gql`
  mutation Mutation($record: UpdateOneAccountInput!, $filter: FilterUpdateOneAccountInput) {
    accountUpdateOne(record: $record, filter: $filter) {
      record {
        email
        role
      }
    }
  }
`;

const templates = gql`
  query EmailTemplateFindMany($filter: FilterFindManyEmailTemplateInput) {
    emailTemplateFindMany(filter: $filter) {
      _id
      name
      subject
      content
    }
  }
`;

const addTemplate = gql`
  mutation Mutation($record: CreateOneEmailTemplateInput!) {
    emailTemplateCreateOne(record: $record) {
      recordId
    }
  }
`;

const removeTemplate = gql`
  mutation Mutation($id: MongoID!) {
    emailTemplateRemoveById(_id: $id) {
      recordId
    }
  }
`;

export default {
  query,
  account,
  accounts,
  listingDac,
  updateGuests,
  updateAccount,
  templates,
  addTemplate,
  removeTemplate,
};
